import { LinkCtaFragment } from '@graphql/generated/graphql';
import { CompanyConfig } from '@lib/config/getCompanyConfig';
import { Platform } from '@lib/embed/providers/EmbedProvider';
import { SanitizedStoryPage } from '@lib/pimster-stories/types';
import { transform } from '@lib/string-rewriter';
import { isSomething } from '@utils/isSomething';

export const getStoryPageLinks = (
    storyPage?: SanitizedStoryPage | null
): LinkCtaFragment[] => {
    const components = storyPage?.ctas?.map((cta) =>
        cta.__typename === 'ComponentCtaLinkCallToAction'
            ? (cta as LinkCtaFragment)
            : undefined
    );
    return components?.filter(isSomething) || [];
};

export const resolveLinkUrl = (
    link: LinkCtaFragment,
    context: {
        platform?: Platform;
        companyConfig?: CompanyConfig;
    }
): string => {
    const originalUrl = link.Url;
    if (!context.platform || !context.companyConfig) return originalUrl;
    const { platform, companyConfig } = context;
    if (platform === 'web' || !companyConfig.cta.deeplinkRewriteRules) {
        return originalUrl;
    }
    const rule = companyConfig.cta.deeplinkRewriteRules[platform];
    if (rule) return transform(originalUrl, rule) || originalUrl;
    return originalUrl;
};
